// Deliberately accepts only a fixed code: never pass request bodies, photos or tokens.
const codes = new Set(['SF_DRAFT_SAVE_FAILED','SF_DRAFT_SEND_FAILED','SF_UPDATE_FAILED','SF_CAMERA_PLAY_FAILED'])
export function reportPwaError(code) {
  if (!codes.has(code)) return
  console.warn(`[SmartFarm] ${code}`)
  window.dispatchEvent(new CustomEvent('smartfarm:diagnostic', { detail: { code, at: new Date().toISOString() } }))
}
